import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IdleService } from './idle.service';
import { environment } from 'src/environments/environment';
import { SignupService } from './common-service/signup.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent  { 
  title = 'DCI';
  idleTimer = true;

  constructor(private idleService: IdleService,public router: Router, public signin:SignupService, public spinner: NgxSpinnerService) {

    // Start -- For Local and Session Storage
    if(window.addEventListener) {
    window.addEventListener('storage', (event) => {
      if(event != null && event != undefined) { 
      if (event.key == 'getSessionStorage') {
        localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
        localStorage.removeItem('sessionStorage'); 
      } else if (event.key == 'sessionStorage' && !sessionStorage.length) {
        var data = JSON.parse(event.newValue);
        for (var key in data) {
          sessionStorage.setItem(key, data[key]);
        }
        if(window.location.href.endsWith("/login") || window.location.href.endsWith("/")) {
          this.router.navigate(['/main/internal/dashboard']);
        }       
      } 
    }
    });
    } else {
      (<any>window).attachEvent("onstorage", localStorage);
    };
     if (!sessionStorage.length) {
       localStorage.setItem('getSessionStorage',  JSON.stringify(localStorage));
       localStorage.removeItem('getSessionStorage');
      
     };
     // End --
   }

  ngOnInit(): void {
    this.initialIdleSettings();
  }


  private initialIdleSettings() {
    const idleTimeoutInSeconds: number = environment.idleTimeInMinutes * 60;
    this.idleService.startWatching(idleTimeoutInSeconds).subscribe((isTimeOut: boolean) => {
      if (isTimeOut) {
        this.sessionTimeoutAuditLog();
      }
    });
  }

  sessionTimeoutAuditLog() {
    this.signin.getSessionTimeoutAuditLog().subscribe((res: any) => {    
      this.signin.deleteOauthToken().subscribe((result: any) => {      
      });       
    },
    error => {
      if(sessionStorage.getItem('selectedRole-usec') == 'Student') {
        this.router.navigate(['/login/student']);
      } else {
        this.router.navigate(['/login']);
      }   
      this.clearSession();
      console.log(error, "Session Time out");
    });
  }

  clearSession() {
    sessionStorage.clear();
    localStorage.clear();
  }

  // resubscribe(): void {
  //   this.idleTimer = true;
  //   this.timerSubscribe();
  // }

  // private timerSubscribe(): void {
  //   this._idleService
  //     .idleStateChanged()
  //     .subscribe(
  //       val => {
  //         if (val === IdleWarningStates.SecondaryTimerExpired) {
  //           this._idleService.stopTimer();
  //           this.idleTimer = false;
  //           sessionStorage.clear();
  //           this.router.navigate(['/']);
  //         }
  //       }
  //     );
  // }
}